var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMovecards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15026_127153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.35391 7.41125C2.35391 6.29038 2.79917 5.21542 3.59175 4.42284C4.38432 3.63026 5.45929 3.185 6.58016 3.185H10.5002V5.25L13.1252 2.625L10.5002 0V1.96H6.58016C5.1344 1.96 3.74785 2.53433 2.72554 3.55663C1.70323 4.57894 1.12891 5.96549 1.12891 7.41125C1.12891 8.85701 1.70323 10.2436 2.72554 11.2659C3.74785 12.2882 5.1344 12.8625 6.58016 12.8625H7.00016V11.6375H6.58016C5.46 11.6352 4.38638 11.1892 3.5943 10.3971C2.80223 9.60503 2.35622 8.53141 2.35391 7.41125ZM7.87516 8.4875H13.1252V7.2625H7.87516V8.4875ZM7.87516 12.8625H13.1252V11.6375H7.87516V12.8625Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15026_127153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMovecards);
export default __webpack_public_path__ + "static/media/movecards.fc506eb89ced58837d14128cd4cd95df.svg";
export { ForwardRef as ReactComponent };